import React from "react";
import { Field, reduxForm } from "redux-form";
import { renderTextField, renderSelectField } from "../helpers/formFields";

import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import MenuItem from '@mui/material/MenuItem';

import { countries } from "../helpers/dataOptions";
import { GoogleLogo } from "../helpers/Logos";

class BusinessForm extends React.Component {

    onSubmit = (formValues) => {
        this.props.onSubmit(formValues);
    }

    renderSignUpButton(flow) {
        if (flow === 'google') {
            return (
                <Button
                    type="submit"
                    fullWidth
                    startIcon={GoogleLogo(20,20)}
                    variant="outlined"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Register with Google
                </Button>
            )
        }
        else {
            return (
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Register
                </Button>
            )
        }
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit(this.onSubmit)}>

                <Field
                    name="businessname"
                    id="businessname"
                    component={renderTextField}
                    label="Business name"
                    margin="normal"
                    required
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Field
                    name="businessnumber"
                    id="businessnumber"
                    component={renderTextField}
                    label="Business registration number"
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Typography variant="body" display="block" color="text.secondary" sx={{ mt: 3, mb: 3 }}>
                    Please provide your business address
                </Typography>
                <Field
                    name="business_email"
                    id="business_email"
                    component={renderTextField}
                    label="Business Email Address"
                    autoComplete="email"
                    margin="normal"
                    required
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Typography variant="body2" display="block" color="text.secondary" gutterBottom sx={{ mb: 3 }}>
                    Email where we will contact you about business related topics e.g. invoice
                </Typography>
                <Field
                    name="country"
                    component={renderSelectField}
                    label="Country"
                    required={true}
                >
                    <MenuItem value="" />
                    {countries.map(country => (
                        <MenuItem value={country.label} key={country.label}>{country.label}</MenuItem>
                    ))}

                </Field>
                <Field
                    name="street"
                    id="street"
                    component={renderTextField}
                    label="Street address"
                    margin="normal"
                    fullWidth
                    required
                    InputLabelProps={{ shrink: true }}
                />
                <Field
                    name="city"
                    id="city"
                    component={renderTextField}
                    label="City"
                    margin="normal"
                    fullWidth
                    required
                    InputLabelProps={{ shrink: true }}
                />
                <Field
                    name="postcode"
                    id="postcode"
                    component={renderTextField}
                    label="Postal code"
                    margin="normal"
                    fullWidth
                    required
                    InputLabelProps={{ shrink: true }}
                />
                {this.renderSignUpButton(this.props.flow)}
            </form>
        )
    }
}

const validate = (formValues) => {
    const errors = {};

    if (!formValues.businessname) {
        errors.password = 'You did not enter a business name';
    }

    return errors;
};

export default reduxForm({
    form: 'accountForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate: validate
})(BusinessForm);